import dayjs from 'dayjs'
import { Loading } from 'element-ui'

// 全局loading实例
let loadingInstance
export default {
  install(Vue) {
    // 注入script标签
    Vue.prototype.$script = (src) => {
      return new Promise((resolve, reject) => {
        try {
          const head = document.head || document.getElementsByTagName('head')[0]
          const script = document.createElement('script')
          if (!('onload' in script)) {
            script.onreadystatechange = () => {
              if (this.readyState !== 'complete' && this.readyState !== 'loaded') {
                return
              }
              this.onreadystatechange = null
              resolve()
            }
          }
          script.onload = () => {
            this.onload = null
            resolve()
          }
          script.type = 'text/javascript'
          script.src = src
          head.appendChild(script)
        } catch (error) {
          reject(error)
        }
      })
    }
    // 使用Blob下载流文件
    Vue.prototype.$downloadBolb = function(file, fileName) {
      const link = document.createElement('a')
      // 创建Blob对象，设置文件类型
      const blob = new Blob([file])
      const objectUrl = URL.createObjectURL(blob) // 创建URL
      link.href = objectUrl
      link.download = fileName // 自定义文件名
      link.click() // 下载文件
      URL.revokeObjectURL(objectUrl) // 释放内存
    }

    // 格式化时间
    Vue.prototype.$fmtTime = function(time, fmt = 'YYYY-MM-DD HH:mm') {
      if (!time) { return '' }
      return dayjs(time).format(fmt)
    }

    // 空值显示
    Vue.prototype.$fmtValue = function(val, emptyShow = '') {
      return !val && val !== 0 ? emptyShow : val
    }

    // 整页全局loading
    Vue.prototype.$fullLoading = {
      open(text) {
        const options = {
          lock: true,
          text: text || '请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          customClass: 'loading-position'
        }
        loadingInstance = Loading.service(options)
      },
      close() {
        loadingInstance && loadingInstance.close()
      }
    }

    // 防抖
    Vue.prototype.$debounce = function(func, wait, immediate) {
      let timeout
      return function() {
        const that = this
        const args = arguments
        if (timeout) {
          clearTimeout(timeout)
        }
        if (immediate) {
          const callNow = !timeout
          timeout = setTimeout(() => {
            timeout = null
          }, wait)
          if (callNow) {
            func.apply(that, args)
          }
        } else {
          timeout = setTimeout(function() {
            func.apply(that, args)
          }, wait)
        }
      }
    }

    // 节流
    Vue.prototype.$throttle = function(func, wait) {
      let timeout
      return function() {
        const that = this
        const args = arguments
        if (!timeout) {
          timeout = setTimeout(function() {
            func.apply(that, args)
            timeout = null
          }, wait)
        }
      }
    }

    // 相对路径的图片自动添加域名
    Vue.prototype.$staticHost = function(path) {
      if (/^http.*/i.test(path)) {
        return path
      }
      if (!/^\/.*/.test(path)) {
        path = `/${path}`
      }
      return `${process.env.VUE_APP_STATIC_HOST}${path}`
    }

    Vue.prototype.$handleDoubleSpeedData = function(data1, data2) {
      if (data1 && data2) {
        return `${data1}/${data2}`
      } else if (data1 && !data2) {
        return `${data1}/`
      } else if (!data1 && data2) {
        return `/${data2}`
      }
      return null
    }
  }
}
